import { Team } from '../../Api/teams/teams.types'
import {
  APP_LINK_BASE_URL,
  PLL_LINKS,
} from '../../Config/League/league.config'

export const APP_LINKS = {
  homeCallout: PLL_LINKS.homepageAppLink,
  scoresCallout: `${APP_LINK_BASE_URL}/web-scores`,
}


export const createTeamDynamicLink = (
  team: Team,
  tab: string = 'overview'
) => {
  return `https://premierlacrosseleague.com/teams/${team.fullName}`
}

export const createMatchupPreviewDynamicLink = (eventSlug: string) => {
  return `https://premierlacrosseleague.com/matchup/${eventSlug}`
}